<div class="global-nav-container">
  <app-global-header [sidebarMetadata]="sidebarMetadata" [hidden]="!showHeaderandFooter"></app-global-header>
  <app-search-window *ngIf="globals.isBrowser"></app-search-window>
</div>
<router-outlet></router-outlet>
<app-footer *ngIf= "showHeaderandFooter"
[ngClass]="globalFooterOffset
? '-footer-offset' : footerFor === 'smb'
? '-add-margin-smb' : footerFor === 'enterprise'
? '-add-margin-enterprise' : footerFor === 'platforms'
? '-add-margin-platforms' : footerFor === 'payfac'
? '-add-margin-payfac' : footerFor === 'financial-institution'
? '-add-margin-financial-institution' : footerFor === 'independent-sales-organization'
? '-add-margin-independent-sales-organization' : footerFor === 'independent-software-vendor'
? '-add-margin-independent-software-vendor' : ''"
></app-footer>
